import React, { useEffect, useState } from 'react'
import { PlusLg } from 'react-bootstrap-icons'
import { useLocation, NavigateFunction, useNavigate, useParams, useSearchParams } from 'react-router-dom'

import gear from '../../assets/icons/gear.png'
import ListNoItems from '../../components/_atoms/ListNoItems/ListNoItems'
import ListPagination from '../../components/_atoms/ListPagination/ListPagination'
import SalesButton from '../../components/_atoms/SalesButton/SalesButton'
import SalesText from '../../components/_atoms/SalesText/SalesText'
import ModalCustomizableColumns from '../../components/_molecules/ModalCustomizableColumns/ModalCustomizableColumns'
import ModalEditCar from '../../components/_molecules/ModalEditCar/ModalEditCar'
import ModalDeleteCar from '../../components/_molecules/ModelDeleteCar/ModelDeteteCar'
import SearchComponent from '../../components/_molecules/SearchComponent/SearchComponent'
import { TableCarList } from '../../components/_orgamisms/TableCarList/TableCarList'
import {
    allCustomizableColumnsCar,
    defaultCustomizableColumnsCar,
    getOrderColumns,
} from '../../constants/defaultCustomizableColumns'
import { colors, fontSizes, fontWeights } from '../../constants/salesStyles'
import DatahubApiService from '../../modules/api/DatahubApiService'
import LoadCarList from '../../modules/redux/carList/LoadCarList'
import { useDispatch } from '../../modules/store/customDispatch'
import { useSelector } from '../../modules/store/customSelector'
import { useLazyGetUserActiveColumnsCarListQuery } from '../../modules/store/datahubApi/datahubApi'
import { Column } from '../../modules/store/partList/partListReducer'
import { storeDispatchTypes } from '../../modules/store/storeDispatchTypes'
import { adminRouteAlias, getAdminNavigationPath } from '../../router/adminRouteAlias'
import { Car, CarListPageParams } from '../../types/car/carTypes'

import styles from './styles.module.scss'

const CarList = () => {
    const params = useParams<CarListPageParams>()
    const dispatch = useDispatch()
    const [perPage] = useState(50)

    // Модалки
    const [isModalOpen, setIsModalOpen] = useState(false)
    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false)
    const [isCustomizableColumnsModalOpen, setIsCustomizableColumnsModalOpen] = useState(false)

    const [currentCar, setCurrentCar] = useState<Car | null>(null)

    const itemsCount = useSelector(state => state.carList.carList.dataCount || 0)
    const itemsTotal = useSelector(state => state.carList.carList.total)
    const isLoading = useSelector(state => state.carList.isLoading)
    const cars = useSelector(state => state.carList.carList.data)

    //Sort
    const sortOrder = useSelector(state => state.carList.sortOrder)

    // Select Search Filters
    const markId = useSelector(state => state.carList.filters.markId)
    const modelId = useSelector(state => state.carList.filters.modelId)
    const modificationId = useSelector(state => state.carList.filters.modificationId)
    const bodyTypeId = useSelector(state => state.carList.filters.bodyTypeId)

    // search filter car title
    const carName = useSelector(state => state.carList.filters.carName)

    //Range filters
    const partsCntRange = useSelector(state => state.carList.filters.partsCntRange)
    const partsCntFrom = useSelector(state => state.carList.filters.partsCntRange?.from)
    const partsCntTo = useSelector(state => state.carList.filters.partsCntRange?.to)

    const priceRange = useSelector(state => state.carList.filters.priceRange)
    const priceFrom = useSelector(state => state.carList.filters.priceRange?.from)
    const priceTo = useSelector(state => state.carList.filters.priceRange?.to)

    const mileageRange = useSelector(state => state.carList.filters.mileageRange)
    const mileageFrom = useSelector(state => state.carList.filters.mileageRange?.from)
    const mileageTo = useSelector(state => state.carList.filters.mileageRange?.to)
    const page = useSelector(state => state.carList.filters.page)

    const location = useLocation()
    const navigate: NavigateFunction = useNavigate()

    // Параметры поиска
    const [searchParams, setSearchParams] = useSearchParams()
    const [searchParamsLoaded, setSearchParamsLoaded] = useState(0)
    const searchParamPage = searchParams.get('p')
    const searchParamMarkId = searchParams.get('markId')
    const searchParamModelId = searchParams.get('modelId')
    const searchParamModificationId = searchParams.get('modificationId')
    const searchParamBodyTypeId = searchParams.get('bodyTypeId')
    const searchParamMileageFrom = searchParams.get('mileageFrom')
    const searchParamMileageTo = searchParams.get('mileageTo')
    const searchParamPriceFrom = searchParams.get('priceFrom')
    const searchParamPriceTo = searchParams.get('priceTo')
    const searchParamPartsCntFrom = searchParams.get('partsCntFrom')
    const searchParamPartsCntTo = searchParams.get('partsCntTo')
    const searchParamSortOrder = searchParams.get('sortOrder')
    const searchParamCarName = searchParams.get('carName')

    const navigateWithParams = (carId = '') => {
        const queryParams = new URLSearchParams(location.search)

        if (carId) {
            if (params.carId !== carId) {
                navigate(`/admin/cars/${carId}?${queryParams.toString()}`)
            }
        } else {
            navigate(`/admin/cars?${queryParams.toString()}`)
        }
    }

    // Главный поиск
    const setNameSearch = (searchTerm: string) => {
        dispatch({
            type: storeDispatchTypes.setCarNameTextFilterCars,
            value: {
                carName: searchTerm,
            },
        })
    }

    const filterCarsByMarkId = (markId: number | string) => {
        dispatch({
            type: storeDispatchTypes.setMarkFilterCars,
            value: {
                filterId: markId,
            },
        })
    }

    const filterCarsByModelId = (modelId: number | string) => {
        dispatch({
            type: storeDispatchTypes.setModelFilterCars,
            value: {
                filterId: modelId,
            },
        })
    }

    const filterCarsByModificationId = (modificationId: number | string) => {
        dispatch({
            type: storeDispatchTypes.setModificationFilterCars,
            value: {
                filterId: modificationId,
            },
        })
    }

    const filterCarsByBodyTypeId = (bodyTypeId: number | string) => {
        dispatch({
            type: storeDispatchTypes.setBodyTypeFilterCars,
            value: {
                filterId: bodyTypeId,
            },
        })
    }

    const filterCarsByMileageRange = (mileageFrom: string | null, mileageTo: string | null) => {
        dispatch({
            type: storeDispatchTypes.setMileageRange,
            value: {
                from: mileageFrom,
                to: mileageTo,
            },
        })
    }

    const filterCarsByPriceRange = (priceFrom: string | null, priceTo: string | null) => {
        dispatch({
            type: storeDispatchTypes.setPriceRangeCars,
            value: {
                from: priceFrom,
                to: priceTo,
            },
        })
    }

    const filterCarsByPartsCntRange = (partsCntFrom: string | null, partsCntTo: string | null) => {
        dispatch({
            type: storeDispatchTypes.setPartsCountRangeCars,
            value: {
                from: partsCntFrom,
                to: partsCntTo,
            },
        })
    }

    const filterCarsBySortOrder = (sortField: string, sortOrder: string) => {
        dispatch({
            type: storeDispatchTypes.setCarListSort,
            value: {
                sortField,
                sortOrder,
            },
        })
    }

    // Загрузка параметров из строки поиска
    useEffect(() => {
        if (searchParamPage !== `${page}` && (searchParamPage !== null || page !== 1)) {
            dispatch({
                type: storeDispatchTypes.setPageFilterParts,
                value: { page: Number(searchParamPage) > 1 ? Number(searchParamPage) : 1 },
            })
        }

        if (searchParamMarkId !== `${markId}` && (searchParamMarkId || markId !== undefined)) {
            filterCarsByMarkId(searchParamMarkId ? Number(searchParamMarkId) : '')
        }

        if (searchParamModelId !== `${modelId}` && (searchParamModelId || modelId !== undefined)) {
            filterCarsByModelId(searchParamModelId ? Number(searchParamModelId) : '')
        }

        if (
            searchParamModificationId !== `${modificationId}` &&
            (searchParamModificationId || modificationId !== undefined)
        ) {
            filterCarsByModificationId(searchParamModificationId ? Number(searchParamModificationId) : '')
        }

        if (searchParamBodyTypeId !== `${bodyTypeId}` && (searchParamBodyTypeId || bodyTypeId !== undefined)) {
            filterCarsByBodyTypeId(searchParamBodyTypeId ? Number(searchParamBodyTypeId) : '')
        }

        if (
            searchParamMileageFrom !== `${mileageFrom}` ||
            (searchParamMileageFrom === null && mileageFrom !== undefined) ||
            searchParamMileageTo !== `${mileageTo}` ||
            (searchParamMileageTo === null && mileageTo !== undefined)
        ) {
            if (
                searchParamMileageFrom ||
                mileageFrom !== undefined ||
                searchParamMileageTo ||
                mileageTo !== undefined
            ) {
                filterCarsByMileageRange(searchParamMileageFrom, searchParamMileageTo)
            }
        }

        if (
            searchParamPriceFrom !== `${priceFrom}` ||
            (searchParamPriceFrom === null && priceFrom !== undefined) ||
            searchParamPriceTo !== `${priceTo}` ||
            (searchParamPriceTo === null && priceTo !== undefined)
        ) {
            if (searchParamPriceFrom || priceFrom !== undefined || searchParamPriceTo || priceTo !== undefined) {
                filterCarsByPriceRange(searchParamPriceFrom, searchParamPriceTo)
            }
        }

        if (
            searchParamPartsCntFrom !== `${partsCntFrom}` ||
            (searchParamPartsCntFrom === null && partsCntFrom !== undefined) ||
            searchParamPartsCntTo !== `${partsCntTo}` ||
            (searchParamPartsCntTo === null && partsCntTo !== undefined)
        ) {
            if (
                searchParamPartsCntFrom ||
                partsCntFrom !== undefined ||
                searchParamPartsCntTo ||
                partsCntTo !== undefined
            ) {
                filterCarsByPartsCntRange(searchParamPartsCntFrom, searchParamPartsCntTo)
            }
        }

        if (searchParamCarName !== carName && (searchParamCarName || carName !== undefined)) {
            setNameSearch(searchParamCarName ? searchParamCarName : '')
        }

        if (searchParamSortOrder && searchParamSortOrder !== sortOrder.map(pair => pair.join(',')).join(',')) {
            const searchParamsSet = new Set(searchParamSortOrder.match(/[^,]+,[^,]+/g))
            const sortOrderSet = new Set(sortOrder.map(pair => pair.join(',')))

            // Для каждой пары из sortOrder, которая не содержится в searchParamSortOrder
            sortOrder.forEach(pair => {
                const pairString = pair.join(',')
                if (!searchParamsSet.has(pairString)) {
                    filterCarsBySortOrder(pair[0], 'NONE')
                }
            })

            // Для каждой пары из searchParamSortOrder, которая не содержится в sortOrder
            searchParamsSet.forEach(param => {
                if (!sortOrderSet.has(param)) {
                    const [field, order] = param.split(',')
                    filterCarsBySortOrder(field, order)
                }
            })
        } else if (!searchParamSortOrder) {
            for (const field of sortOrder) {
                filterCarsBySortOrder(field[0], 'NONE')
            }
        }

        setSearchParamsLoaded(1)
    }, [searchParams])

    // Загрузка параметров в строку поиска
    useEffect(() => {
        if (!searchParamsLoaded) {
            return
        }

        // Текущие параметры
        const currentPage = page > 1 ? `${page}` : null
        const currentMarkId = markId ? `${markId}` : null
        const currentModelId = modelId ? `${modelId}` : null
        const currentModificationId = modificationId ? `${modificationId}` : null
        const currentBodyTypeId = bodyTypeId ? `${bodyTypeId}` : null
        const currentMileageFrom = mileageFrom ? `${mileageFrom}` : null
        const currentMileageTo = mileageTo ? `${mileageTo}` : null
        const currentPriceFrom = priceFrom ? `${priceFrom}` : null
        const currentPriceTo = priceTo ? `${priceTo}` : null
        const currentPartsCntFrom = partsCntFrom ? `${partsCntFrom}` : null
        const currentPartsCntTo = partsCntTo ? `${partsCntTo}` : null
        const currentSortOrder = sortOrder.length ? sortOrder : null
        const currentCarName = carName ? `${carName}` : null

        // Проверяем, изменились ли параметры строки поиска
        const pageChanged = searchParamPage !== currentPage
        const markIdChanged = searchParamMarkId !== currentMarkId
        const modelIdChanged = searchParamModelId !== currentModelId
        const modificationIdChanged = searchParamModificationId !== currentModificationId
        const bodyTypeIdChanged = searchParamBodyTypeId !== currentBodyTypeId
        const mileageFromChanged = searchParamMileageFrom !== currentMileageFrom
        const mileageToChanged = searchParamMileageTo !== currentMileageTo
        const priceFromChanged = searchParamPriceFrom !== currentPriceFrom
        const priceToChanged = searchParamPriceTo !== currentPriceTo
        const partsCntFromChanged = searchParamPartsCntFrom !== currentPartsCntFrom
        const partsCntToChanged = searchParamPartsCntTo !== currentPartsCntTo
        const carNameChanged = searchParamCarName !== currentCarName

        let sortOrderChanged = false
        if (searchParamSortOrder) {
            const searchParamsSet = new Set(searchParamSortOrder.match(/[^,]+,[^,]+/g))
            const sortOrderSet = new Set(sortOrder.map(pair => pair.join(',')))

            sortOrder.forEach(pair => {
                const pairString = pair.join(',')
                if (!searchParamsSet.has(pairString)) {
                    sortOrderChanged = true
                    return
                }
            })

            searchParamsSet.forEach(param => {
                if (!sortOrderSet.has(param)) {
                    sortOrderChanged = true
                    return
                }
            })
        } else if (!searchParamSortOrder && currentSortOrder) {
            sortOrderChanged = true
        }

        const searchParamsChanged =
            pageChanged ||
            markIdChanged ||
            modelIdChanged ||
            priceFromChanged ||
            priceToChanged ||
            modificationIdChanged ||
            bodyTypeIdChanged ||
            mileageFromChanged ||
            mileageToChanged ||
            partsCntFromChanged ||
            partsCntToChanged ||
            sortOrderChanged ||
            carNameChanged

        if (searchParamsChanged) {
            setSearchParams({
                ...(page > 1 ? { p: '' + page } : {}),
                ...(markId ? { markId: '' + markId } : {}),
                ...(modelId ? { modelId: '' + modelId } : {}),
                ...(modificationId ? { modificationId: '' + modificationId } : {}),
                ...(bodyTypeId ? { bodyTypeId: '' + bodyTypeId } : {}),
                ...(mileageFrom ? { mileageFrom: '' + mileageFrom } : {}),
                ...(mileageTo ? { mileageTo: '' + mileageTo } : {}),
                ...(priceFrom ? { priceFrom: '' + priceFrom } : {}),
                ...(priceTo ? { priceTo: '' + priceTo } : {}),
                ...(partsCntFrom ? { partsCntFrom: '' + partsCntFrom } : {}),
                ...(partsCntTo ? { partsCntTo: '' + partsCntTo } : {}),
                ...(sortOrder && sortOrder.length !== 0 ? { sortOrder: '' + sortOrder } : {}),
                ...(currentCarName ? { carName: `${currentCarName}` } : {}),
            })
        }

        // load cars list data
        dispatch(
            LoadCarList(
                page,
                perPage,
                markId,
                modelId,
                modificationId,
                bodyTypeId,
                partsCntRange && { from: partsCntFrom, to: partsCntTo },
                priceRange && { from: priceFrom, to: priceTo },
                mileageRange && { from: mileageFrom, to: mileageTo },
                sortOrder,
                carName,
            ),
        )
    }, [
        searchParamsLoaded,
        page,
        perPage,
        markId,
        modelId,
        modificationId,
        bodyTypeId,
        partsCntFrom,
        partsCntTo,
        priceFrom,
        priceTo,
        mileageFrom,
        mileageTo,
        sortOrder,
        carName,
    ])

    const openEditModal = (car: Car) => {
        navigateWithParams(car.id)

        setCurrentCar(car)
        setIsModalOpen(true)
    }

    const handleClose = () => {
        navigateWithParams()
        setIsModalOpen(false)
    }

    const getCarById = async () => {
        if (params.carId) {
            const car = await DatahubApiService.getCarByCarId(params.carId)

            if (car) {
                openEditModal(car)
            }
        }
    }

    const openDeleteModal = (car: Car) => {
        setCurrentCar(car)
        setIsDeleteModalOpen(true)
    }

    // open modal by carId
    useEffect(() => {
        if (params.carId) {
            getCarById()
        } else {
            setIsModalOpen(false)
        }
    }, [params.carId])

    // Сброс фильтров при уходе со страницы
    useEffect(
        () => () => {
            dispatch({
                type: storeDispatchTypes.resetFiltersCars,
            })
        },
        [],
    )

    const [getUserActiveColumnsCarList, { data: userActiveColumnsCarList }] = useLazyGetUserActiveColumnsCarListQuery()
    const [customizableColumns, setCustomizableColumns] = useState<Column[]>(defaultCustomizableColumnsCar)

    useEffect(() => {
        getUserActiveColumnsCarList()
    }, [getUserActiveColumnsCarList])

    useEffect(() => {
        const activeColumnsCarList = userActiveColumnsCarList?.data?.activeColumnsCarList
        if (!activeColumnsCarList) return

        setCustomizableColumns(
            getOrderColumns({
                order: activeColumnsCarList,
                defaultColumns: allCustomizableColumnsCar,
            }),
        )
    }, [dispatch, userActiveColumnsCarList?.data?.activeColumnsCarList])

    return (
        <div className={styles.wrap}>
            {isModalOpen && currentCar && (
                <ModalEditCar car={currentCar} isOpen={isModalOpen} closeModal={() => handleClose()} />
            )}
            {isDeleteModalOpen && currentCar && (
                <ModalDeleteCar
                    car={currentCar}
                    isOpen={isDeleteModalOpen}
                    closeModal={() => setIsDeleteModalOpen(false)}
                />
            )}
            {isCustomizableColumnsModalOpen && (
                <ModalCustomizableColumns
                    isOpen={isCustomizableColumnsModalOpen}
                    closeModal={() => setIsCustomizableColumnsModalOpen(false)}
                    customizableColumns={customizableColumns}
                    isCarColumns
                />
            )}

            <div className={styles.titleWrap}>
                <SalesText
                    text={'Автомобили'}
                    fontWeight={fontWeights.bold}
                    fontSize={fontSizes.xxl}
                    letterSpacing={-0.02}
                />
            </div>

            <div className={styles.rowWrap}>
                <SearchComponent
                    oldSearchTerm={carName}
                    setSearchTerm={setNameSearch}
                    resultCount={itemsCount !== itemsTotal ? itemsCount : undefined}
                    placeholder={'Поиск по названию, марке, модели, VIN и номеру'}
                />
                <SalesButton
                    borderRadius={10}
                    backgroundColor={colors.blueLight}
                    paddingHorizontalPixels={20}
                    paddingVerticalPixels={6}
                    onClick={() => navigate(getAdminNavigationPath(adminRouteAlias.newCar.location))}
                >
                    <>
                        <PlusLg size={24} color={colors.white} />
                        <SalesText
                            text={'Добавить авто'}
                            marginLeftPixels={10}
                            fontSize={fontSizes.s}
                            color={colors.white}
                        />
                    </>
                </SalesButton>
            </div>

            <div className={styles.rowWrap}>
                <SalesButton
                    borderRadius={10}
                    hoverBackgroundColor={colors.grayLighter}
                    paddingHorizontalPixels={20}
                    paddingVerticalPixels={7}
                    marginLeftAuto
                    onClick={() => setIsCustomizableColumnsModalOpen(true)}
                >
                    <img src={gear} alt="gear" style={{ height: '24px' }} />
                </SalesButton>
                {!isLoading && cars.length === 0 ? (
                    <></>
                ) : (
                    <ListPagination
                        page={page}
                        setPage={page =>
                            dispatch({
                                type: storeDispatchTypes.setPageFilterCars,
                                value: { page },
                            })
                        }
                        perPage={perPage}
                        itemsCount={itemsCount}
                    />
                )}
            </div>

            <TableCarList
                columns={customizableColumns}
                cars={cars}
                isLoading={isLoading}
                openEditModal={openEditModal}
                openDeleteModal={openDeleteModal}
            />

            {!isLoading && cars.length === 0 ? (
                <ListNoItems slice={'carList'} />
            ) : (
                <ListPagination
                    page={page}
                    setPage={page =>
                        dispatch({
                            type: storeDispatchTypes.setPageFilterCars,
                            value: { page },
                        })
                    }
                    perPage={perPage}
                    itemsCount={itemsCount}
                    justifyContent={'flex-end'}
                />
            )}
        </div>
    )
}

export default CarList
